import { createSelector } from 'reselect'
import someRequestIsPendingSelector from './pending-request/someRequestIsPendingSelector'

const showLoadingCursorSelector = createSelector(
    someRequestIsPendingSelector,
    (someRequestIsPending): boolean => someRequestIsPending,
)

export default showLoadingCursorSelector
